export enum WidgetActionsSelector {
  SELECTED_ACCOUNT_CURRENCY_CHANGE = 'selectedAccountCurrencyChanged',
}

export enum TemplateHandlebarKeysToCheck {
  FETCH_TOTAL_WEALTH = 'fetchTotalWealth',
}

/**
 * This map stores the handlebar keys that could be associated with widget actions
 * we pass the key from the widget and the value is the list of possible handlebar keys
 * Add new keys here as we provide the feature on other widgets
 */
export const widgetActionsToHandlebarKeyMap = new Map<WidgetActionsSelector, string[]>([
  [WidgetActionsSelector.SELECTED_ACCOUNT_CURRENCY_CHANGE, [TemplateHandlebarKeysToCheck.FETCH_TOTAL_WEALTH]],
]);
